import { useEffect, useState } from "react";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MainLogo from "../../assets/MainLogo.webp";
import { TbBasket } from "react-icons/tb";
import { FaHome, FaTshirt } from "react-icons/fa";
import { MdInfo, MdQuestionAnswer } from "react-icons/md";
import { useSelector } from "react-redux";
import "./navbar.css";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [shopOpen, setShopOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const basket = useSelector((state) => state.basket.basket || []);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1050);
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showBasket =
    isDesktop ||
    location.pathname.startsWith("/shop") ||
    location.pathname === "/checkout";

  const closeMenu = () => setToggleMenu(false);
  const closeShop = () => setShopOpen(false);

  return (
    <div className="navbar">
      <div className="content-padding">
        <div className="header-wrapper">
          <div className="navbar-menu">
            {toggleMenu ? (
              <RiMenu3Line
                color="var(--color-subheading)"
                size={27}
                style={{ visibility: "hidden" }}
              />
            ) : (
              <RiMenu3Line
                color="var(--color-subheading)"
                size={27}
                onClick={() => setToggleMenu(true)}
              />
            )}

            <div
              className={`navbar-menu_drawer${toggleMenu ? " open" : ""}`}
              onClick={closeMenu}
            >
              <div
                className="navbar-menu_drawer-content"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="navbar-menu_drawer-close"
                  type="button"
                  aria-label="Close menu"
                  onClick={closeMenu}
                >
                  <RiCloseLine size={28} />
                </button>

                <nav
                  aria-label="Main navigation"
                  className="navbar-menu_drawer-nav"
                >
                  <p>
                    <Link to="/" onClick={closeMenu}>
                      <FaHome style={{ marginRight: 8 }} /> Home
                    </Link>
                  </p>

                  <div className="navbar-menu_drawer-shop">
                    <p>
                      <Link to="/shop" onClick={closeMenu}>
                        <FaTshirt style={{ marginRight: 8 }} /> Shop
                      </Link>
                    </p>

                    <div className="navbar-menu_drawer-shop-sub">
                      <Link to="/shop" onClick={closeMenu}>
                        All
                      </Link>
                      <Link to="/shop?section=tshirts" onClick={closeMenu}>
                        T-Shirts
                      </Link>
                      <Link to="/shop?section=jumpers" onClick={closeMenu}>
                        Jumpers
                      </Link>
                      <Link to="/shop?section=hats" onClick={closeMenu}>
                        Hats
                      </Link>
                    </div>
                  </div>

                  <p>
                    <Link to="/shop/basket" onClick={closeMenu}>
                      <TbBasket style={{ marginRight: 8 }} /> Basket
                    </Link>
                  </p>

                  <p>
                    <Link to="/about" onClick={closeMenu}>
                      <MdInfo style={{ marginRight: 8 }} /> About
                    </Link>
                  </p>

                  <p>
                    <Link to="/faq" onClick={closeMenu}>
                      <MdQuestionAnswer style={{ marginRight: 8 }} /> FAQ
                    </Link>
                  </p>
                </nav>

                <div className="navbar-menu_drawer-footer">
                  <Link to="/privacy" onClick={closeMenu}>
                    Privacy Policy
                  </Link>
                  <Link to="/terms" onClick={closeMenu}>
                    Terms of Service
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="navbar-links_logo">
            <Link to="/">
              <img src={MainLogo} alt="Solo Pints" />
            </Link>
          </div>

          <nav className="navbar-links_container" aria-label="Main navigation">
            <p>
              <Link to="/">Home</Link>
            </p>

            <div
              className={`navbar-shop-dropdown${shopOpen ? " open" : ""}`}
              onMouseEnter={() => setShopOpen(true)}
              onMouseLeave={() => setShopOpen(false)}
            >
              <Link
                to="/shop"
                className="navbar-shop-trigger"
                onClick={closeShop}
              >
                Shop
              </Link>

              <div className="navbar-shop-dropdown-menu">
                <Link to="/shop" onClick={closeShop}>
                  All
                </Link>
                <Link to="/shop?section=tshirts" onClick={closeShop}>
                  T-Shirts
                </Link>
                <Link to="/shop?section=jumpers" onClick={closeShop}>
                  Jumpers
                </Link>
                <Link to="/shop?section=hats" onClick={closeShop}>
                  Hats
                </Link>
              </div>
            </div>

            <p>
              <Link to="/about">About</Link>
            </p>

            <p>
              <Link to="/faq">FAQ</Link>
            </p>
          </nav>

          <div className="navbar-sign">
            <div className="basket" style={{ position: "relative" }}>
              {showBasket ? (
                <>
                  <TbBasket
                    fontSize={30}
                    onClick={() => navigate("/shop/basket")}
                    style={{ cursor: "pointer" }}
                  />
                  {basket.length > 0 && (
                    <span className="basket-notification">{basket.length}</span>
                  )}
                </>
              ) : (
                <FaTshirt
                  fontSize={25}
                  onClick={() => navigate("/shop")}
                  style={{ cursor: "pointer" }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
